<template>
    <v-layout row wrap class="pl-3 pr-2">
        <v-flex xs12>
            <confirmation-header-text
                text="Organizational detail"
                class="ml-2"
                icon="business"
            ></confirmation-header-text>
        </v-flex>
        <v-flex xs12 class="pl-5">
            <v-layout row wrap>
                <v-flex xs12 sm3>
                    <list-item-detail :sub_title="application_data.organization_name === 'Others'?application_data.organization_name+'/'+application_data.other_organization_name:application_data.organization_name"
                                      title="Organization name"
                    ></list-item-detail>
                </v-flex>
                <v-flex xs12 sm3>
                    <list-item-detail :sub_title="application_data.address_of_business_institute"
                                      title="Address"
                    ></list-item-detail>
                </v-flex>
                <v-flex xs12 sm3>
                    <list-item-detail :sub_title="application_data.position"
                                      title="Position in the organization"
                    ></list-item-detail>
                </v-flex>
            </v-layout>
        </v-flex>


    </v-layout>
</template>

<script>
    import ListItemDetail from "../../ListItemDetail";
    import ConfirmationHeaderText from "../../ConfirmationHeaderText";

    export default {
        computed: {
            application_data() {
                return this.$store.state.VisaRequestSingle.visaRequest.extra.application_data;
            }
        },
        components: {
            ListItemDetail, ConfirmationHeaderText
        }
    };
</script>

<style>
</style>
